import { api } from '../api/api'
import { apiNew } from '../api/apiNew'
import { apiWx} from '../api/apiWx'

// 获取旧公式详情数据
export const formulaDetail = params => api('/ysz-content/formula/getDrugFormulaInfo', params);

// 小程序收藏公式
export const saveFormula = params => apiWx('ysz-content/formula/saveFormula', params);

// 小程序删除公式
export const deleteFormulaList = params => apiWx('ysz-content/formula/deleteFormulaList', params);


// 获取路由

export const getFeedbackRouteYsz = params => apiNew('ysz-drug/formula/getFeedbackRoute', params);


// 获取路由
export const getFeedbackRouteWx= params => apiWx('ysz-drug/formula/getFeedbackRoute', params);

// 公式浏览新增奖励会员1.0
export const formulaDetailReport= params => apiWx('ysz-drug/formula/detailReport', params);



// WEBPACK FOOTER //
// ./src/server/oldformula/index.js